import React, { useEffect, useRef } from 'react';
import './VHubAiPage.css';



const VHubAiPage = () => {
  const iframeRef = useRef<any>(null);
  const winobj:any = window;
  const appConfig:any = winobj?.__APP_CONFIG__;

  useEffect(()=>{

  },[])

  const sendMessage = () => {
    const data = { 
      token: `${localStorage.getItem("token")}`,
      orgName: `${localStorage.getItem("orgName")}` ,
      user: `${localStorage.getItem("user")}` 
    };
    
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(data, "*")
    }
  };

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.data.type === "VHUB_READY") {
        sendMessage();
        console.log("Received in B:", event.data.value);
      }
    };

    // Add listener when component mounts
    window.addEventListener('message', handleMessage);

    // Clean up listener when component unmounts to prevent memory leaks
    return () => window.removeEventListener('message', handleMessage);
  }, []);

    return (
        <div>
          <div className="vhub-ai-container">
              <iframe
                ref={iframeRef}
                src="https://d2rx7528f4g2up.cloudfront.net"
                title="vHub AI"
                className="vhub-ai-iframe"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
          </div>
        </div>
    );
};

export default VHubAiPage;